// /Redux/filterSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedState: null,
  selectedCounty: null,
  selectedFips: null,
  landCoverSelections: [],
  prioritySelections: [],
  rankingScore: [],
  selectedCheckboxes: [],
  hydrated: false,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setSelectedState: (state, action) => {
      state.selectedState = action.payload;
    },
    setSelectedCounty: (state, action) => {
      state.selectedCounty = action.payload;
    },
    setSelectedFips: (state, action) => {
      state.selectedFips = action.payload;
    },
    setLandCoverSelections: (state, action) => {
      state.landCoverSelections = action.payload;
      state.selectedCheckboxes = [
        ...action.payload,
        ...(state.prioritySelections || []),
      ];
    },
    setPrioritySelections: (state, action) => {
      state.prioritySelections = action.payload;
      state.selectedCheckboxes = [
        ...(state.landCoverSelections || []),
        ...action.payload,
      ];
    },
    setRankingScore: (state, action) => {
      state.rankingScore = action.payload;
    },
    resetSelections: () => initialState,
    setHydrated: (state) => {
      state.hydrated = true;
    },
  },
});

export const {
  setSelectedState,
  setSelectedCounty,
  setSelectedFips,
  setLandCoverSelections,
  setPrioritySelections,
  setRankingScore,
  resetSelections,
  setHydrated,
} = filterSlice.actions;

export default filterSlice.reducer;
